import { render } from "./AppMenu.vue?vue&type=template&id=306de193"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"
script.render = render

export default script